/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    string, bool, object,
} from 'prop-types';

const useStyles = (theme) => ({
    ErrorMessage: {
        color: theme.palette.chatbotErrorColor,
        'font-size': '10.5px',
        'font-weight': 600,
    },
});

function ErrorMessage(props) {
    const { classes, error, helperText } = props;
    return (
        <span className={classes.ErrorMessage}>
            {error ? helperText : ''}
        </span>
    );
}

ErrorMessage.propTypes = {
    classes: object.isRequired,
    error: bool.isRequired,
    helperText: string.isRequired,
};

export default withStyles(useStyles)(ErrorMessage);
